export default __webpack_public_path__ + "img/eyEOgIDC.3b81e2ab.svg";